var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('ManageBase',[_c('template',{slot:"template"},[_c('Pankuzu'),_c('Title'),_c('SendUserForm',{on:{"go_back":_vm.go_back}})],1)],2)}
var staticRenderFns = []

export { render, staticRenderFns }